import * as React from 'react'
import { ValueComponentProps } from '../../../props'
import DateTimeQuestionViewModel from '../../DateTimeQuestionViewModel'

export default function DateTimeValue({
  vm,
}: ValueComponentProps<DateTimeQuestionViewModel>) {
  return <>{vm.toTextAnswer()}</>
}
